<template>
    <DxPopup
      :visible="trigger.SearchIndividual"
      :drag-enabled="false"
      :close-on-outside-click="false"
      :show-title="true"
      :show-close-button="false"
      :width="500"
      :height="200"
      title="Επιλογή φορέα"
    >
      <DxLookup
        :data-source="organizations"
        value-expr="OrganizationId"
        display-expr="OrganizationDescription"
        placeholder="Επιλέξτε Φορέα"
        v-model="selectedOrganizationId"
        :search-expr="['OrganizationDescription', 'OrganizationAfm']"
      >
        <DxDropDownOptions :shading="false" :full-screen="false" />
      </DxLookup>

      <br />
      <DxButton
        text="Αποθήκευση"
        type="success"
        styling-mode="contained"
        @click="onSave"
      />

      <DxButton
        text="Επιστροφή"
        type="danger"
        styling-mode="contained"
        @click="onClose"
      />
    </DxPopup>
</template>
<script>
import { DxPopup } from "devextreme-vue/popup";
import DxButton from "devextreme-vue/button";
import { DxDropDownOptions, DxLookup } from "devextreme-vue/lookup";

export default {
components:{
    DxPopup,
    DxButton,
    DxDropDownOptions,
    DxLookup
},
props:['trigger','organizations'],
data(){
    return{
        selectedOrganizationId: 0
    }
},
methods:{
    onClose(){
        this.trigger.SearchIndividual = false;
    },
    onSave(){
        if(this.selectedOrganizationId != 0){
            this.organizations.filter(x=>x.OrganizationId == this.selectedOrganizationId).map(x=>x.Send = true);
        }
        this.selectedOrganizationId = 0;
        this.trigger.SearchIndividual = false;
    }

}
}
</script>